import React from 'react';
import { XIcon, UserIcon } from 'lucide-react';
import Card from '../ui/Card';
interface CustomerPLViewProps {
  data: any;
  onClose: () => void;
}
const CustomerPLView: React.FC<CustomerPLViewProps> = ({
  data,
  onClose
}) => {
  const customerData = {
    name: data?.customer || 'Maruti Suzuki',
    revenue: 1710,
    pl: [{
      item: 'Revenue',
      value: 1710,
      percentage: 100
    }, {
      item: 'Cost of Goods Sold',
      value: -1210,
      percentage: -70.8
    }, {
      item: 'Gross Profit',
      value: 500,
      percentage: 29.2
    }, {
      item: 'Operating Expenses',
      value: -240,
      percentage: -14.0
    }, {
      item: 'EBITDA',
      value: 260,
      percentage: 15.2
    }, {
      item: 'Depreciation & Amortization',
      value: -45,
      percentage: -2.6
    }, {
      item: 'EBIT',
      value: 215,
      percentage: 12.6
    }, {
      item: 'Interest & Tax',
      value: -72,
      percentage: -4.2
    }, {
      item: 'Net Profit',
      value: 143,
      percentage: 8.4
    }],
    productMix: [{
      product: 'Lighting',
      revenue: 685,
      margin: 16.2
    }, {
      product: 'Electrical',
      revenue: 512,
      margin: 14.8
    }, {
      product: 'Polymer',
      revenue: 342,
      margin: 13.5
    }, {
      product: 'Safety',
      revenue: 171,
      margin: 15.1
    }]
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-6" data-id="element-11330">
      <div className="bg-white rounded-lg shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto" data-id="element-11331">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-11332">
          <div className="flex items-center" data-id="element-11333">
            <UserIcon size={24} className="text-green-600 mr-3" data-id="element-11334" />
            <div data-id="element-11335">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-11336">
                Customer P&L: {customerData.name}
              </h2>
              <p className="text-sm text-gray-600" data-id="element-11337">
                Detailed profitability analysis
              </p>
            </div>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-11338">
            <XIcon size={24} className="text-gray-500" data-id="element-11339" />
          </button>
        </div>
        {/* Content */}
        <div className="p-6 space-y-6" data-id="element-11340">
          {/* P&L Statement */}
          <Card className="p-6" data-id="element-11341">
            <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-11342">
              Profit & Loss Statement (₹ Cr)
            </h3>
            <div className="space-y-2" data-id="element-11343">
              {customerData.pl.map((item, index) => <div key={index} className={`flex items-center justify-between py-2 px-4 rounded ${item.item === 'Revenue' || item.item === 'Gross Profit' || item.item === 'EBITDA' || item.item === 'Net Profit' ? 'bg-blue-50 font-bold' : 'bg-gray-50'}`} data-id="element-11344">
                  <span className="text-sm text-gray-800" data-id="element-11345">{item.item}</span>
                  <div className="flex items-center space-x-6" data-id="element-11346">
                    <span className={`text-sm font-semibold ${item.value >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-11347">
                      ₹{Math.abs(item.value)} Cr
                    </span>
                    <span className="text-sm text-gray-600 w-16 text-right" data-id="element-11348">
                      {item.percentage > 0 ? '+' : ''}
                      {item.percentage.toFixed(1)}%
                    </span>
                  </div>
                </div>)}
            </div>
          </Card>
          {/* Product Mix */}
          <Card className="p-6" data-id="element-11349">
            <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-11350">
              Product Mix & Margins
            </h3>
            <div className="space-y-3" data-id="element-11351">
              {customerData.productMix.map((product, index) => <div key={index} className="border border-gray-200 rounded-lg p-4" data-id="element-11352">
                  <div className="flex items-center justify-between mb-2" data-id="element-11353">
                    <span className="font-semibold text-gray-800" data-id="element-11354">
                      {product.product}
                    </span>
                    <div className="flex items-center space-x-4" data-id="element-11355">
                      <span className="text-sm text-gray-600" data-id="element-11356">
                        ₹{product.revenue} Cr
                      </span>
                      <span className="text-sm font-semibold text-green-600" data-id="element-11357">
                        {product.margin}% margin
                      </span>
                    </div>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-11358">
                    <div className="bg-blue-600 h-2 rounded-full" style={{
                  width: `${product.revenue / customerData.revenue * 100}%`
                }} data-id="element-11359" />
                  </div>
                </div>)}
            </div>
          </Card>
          {/* Key Insights */}
          <Card className="p-6 bg-green-50 border-2 border-green-200" data-id="element-11360">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-11361">
              Key Insights
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-11362">
              <li className="flex items-start" data-id="element-11363">
                <span className="text-green-600 mr-2" data-id="element-11364">✓</span>
                <span data-id="element-11365">
                  Strong EBITDA margin of 15.2% - above company average
                </span>
              </li>
              <li className="flex items-start" data-id="element-11366">
                <span className="text-green-600 mr-2" data-id="element-11367">✓</span>
                <span data-id="element-11368">
                  Lighting products driving highest revenue contribution
                </span>
              </li>
              <li className="flex items-start" data-id="element-11369">
                <span className="text-green-600 mr-2" data-id="element-11370">✓</span>
                <span data-id="element-11371">Opportunity to increase Safety products penetration</span>
              </li>
            </ul>
          </Card>
        </div>
      </div>
    </div>;
};
export default CustomerPLView;